import React, { useState, useEffect } from "react";
import { Container, Row, Col, Navbar, NavbarBrand, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import Encabezado from "../../components/paciente/Encabezado";
import LateralPersonaje from "../../components/paciente/LateralPersonaje";
import ListaPersonajes from "../../components/paciente/ListaPersonajes";

function Personajes({ persona, setPersona }) {

  Personajes.propTypes = {
    persona: PropTypes.object.isRequired
  }

  const [personaje] = useState(persona.paciente.personaje);
  const [personajeImagen, setPersonajeImagen] = useState(personaje.imagen);

  useEffect(() => { }, [personajeImagen]);

  const navigate = useNavigate();

  return (
    <Container fluid className="min-vh-100 d-flex flex-column">

      <Encabezado persona={persona} />

      <Row className="pt-4 g-0 flex-grow-1">
        <Col xs={3}>
          <LateralPersonaje personaje={personaje} pi={personajeImagen} cambio={false} />
        </Col>
        <Col xs={9}>
          <ListaPersonajes miPersonaje={personajeImagen} setMiPersonaje={setPersonajeImagen} puntajeAcumulado={personaje.puntajeAcumulado} />
        </Col>
      </Row>

      <Navbar bg="dark" variant="dark" fixed="bottom">
        <Container>
          <Button variant="primary" size="lg" onClick={() => navigate("/", { replace: true })}>VOLVER</Button>
        </Container>
      </Navbar>
    </Container>
  );
}

export default Personajes;